module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/bot.22efc793.svg";